import {IStates} from '../models/IStatesModel';
import * as StateActions from '../actions/StatesActions';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';

const statesState: Array<IStates> = [];

export const reducer = createReducer(
  statesState,
  on(StateActions.retrieveStatesAction, state => ([
    ...state
  ])),
  on(StateActions.statesReceivedAction, (state, {states}) => ([
    ...states
  ])),
  on(StateActions.retrieveStatesErrorAction, (state, {error}) => ({
    ...state, ...error
  }))
);

export const getFeature = createFeatureSelector<Array<IStates>>('states');
export const getStates = createSelector(
  getFeature,
  state => state
);
